'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _Object$keys = _interopDefault(require('babel-runtime/core-js/object/keys'));
var _Object$assign = _interopDefault(require('babel-runtime/core-js/object/assign'));
var _classCallCheck = _interopDefault(require('babel-runtime/helpers/classCallCheck'));
var _createClass = _interopDefault(require('babel-runtime/helpers/createClass'));
var utils_js = require('../helpers/utils.js');

var I18n = function () {

  /**
   * The I18n class helps translate strings using a translation dictionary, and
   * optionally some global constants. It's designed to be similar to the
   * Rails I18n API.
   *
   * @class I18n
   * @constructor
   * @param  {object} options.data
   *   An object where keys are the scope, and the values are either a nested
   *   object, or a string.
   * @param  {object} options.globals
   *   An object that represents constants, where the keys and values are only
   *   strings. Useful for site constants, eg. `trial_length` or `total_stores`.
   *   These values can be interpolated into translation strings, eg.
   *   `"Enjoy your %{trial_length} day trial"`.
   */
  function I18n(_ref) {
    var data = _ref.data,
        globals = _ref.globals;

    _classCallCheck(this, I18n);

    this.data = data || {};
    this.globals = globals || {};
  }

  /**
   * Checks if the locals object contains a `count` key indicating that may
   * require pluralization. Requires `translations` to contain keys of `one`,
   * `zero` and `other` to work.
   *
   * @see https://guides.rubyonrails.org/i18n.html#pluralization
   * @static
   * @method needsPluralize
   * @param  {object} translations
   *   An object of translation data, keys represent scope, values are strings
   * @param  {object} locals
   *   Local data about this translation, in this case, a `count` key
   * @return {boolean}
   *   True if the translation needs to handle pluralization, false otherwise
   */


  _createClass(I18n, [{
    key: 'translate',


    /**
     * Given a scope, and optionally some `locals` data, return the translated
     * string. Unlike the Rails i18n API, this does not support bulk, namespace
     * or lazy lookups. There is support for pluralization and defaults though.
     *
     * @see retry()
     * @method translate
     * @throws {Error} If scope is not found in the translation data.
     * @param  {string} scope
     *   The scope is a dot delimited string, eg `forms.label`, which will look
     *   for a key `forms`, that has a nested key `label` in the translation
     *   data given to the `i18n` instance
     * @param  {object} locals
     *   An object that contains information that may change the scope used
     *   for translation. Supports pluralization (`count`), interpolation
     *   and `defaults` (see `retry()`)
     * @return {string}
     *   The translated value for the given scope
     */
    value: function translate(scope) {
      var locals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var allTranslations = _Object$assign({}, this.globals, locals);
      var scopes = scope.split('.');
      var ret = this.data;
      var defaults = [];

      if (locals.hasOwnProperty('defaults')) {
        defaults = locals.defaults;
        delete locals.defaults;
      }

      try {
        // Traverse through the translation data one "scope" at a time
        for (var i = 0, ii = scopes.length; i < ii; i++) {
          ret = ret[scopes[i]];
        }

        // No key? Throw.
        if (typeof ret === 'undefined') {
          throw new ReferenceError();
        }

        // Do we need to change the key to look up the translation?
        if (I18n.needsPluralize(ret, locals)) {
          ret = ret[I18n.getPluralizeKey(ret, locals.count)];
        }

        // Translate string, handling interpolation if required.
        if (_Object$keys(allTranslations).length) {
          return utils_js.template(ret, allTranslations);
        } else {
          return ret;
        }
      } catch (error) {
        // Support retry logic if there are defaults.
        while (typeof ret === 'undefined' && defaults.length) {
          ret = this.retry(defaults.shift());
        }

        if (ret) {
          return ret;
        }

        throw new Error('failed to translate key ' + scope);
      }
    }

    /**
     * Retry is used when attempting to resolve an unknown translation scope. It
     * mirrors the API provided by the `i18n-js` package. Accepts an object that
     * contains either `message` or `scope` key. `scope` will attempt to use
     * `translate` to resolve the given `scope` value. `message` will simply
     * return string value.
     *
     * @private
     * @method retry
     * @param  {object} attempt
     *   An object with `message` or `scope` keys.
     * @param  {object} locals
     *   An object that contains information that may change the scope used
     *   for translation. Supports pluralization (`count`) and interpolation.
     * @return {string|undefined}
     *   The translated value for the given scope, or `undefined`.
     */

  }, {
    key: 'retry',
    value: function retry(attempt, locals) {
      if (attempt.hasOwnProperty('message')) {
        return attempt.message;
      } else if (attempt.hasOwnProperty('scope')) {
        try {
          return this.translate(attempt.scope, locals);
        } catch (err) {
          // Silent catch, we can just try the next default.
        }
      }

      // eslint-disable-next-line no-undefined
      return undefined;
    }

    /**
     * Alias of `translate`.
     *
     * @method t
     * @see `translate`
     */

  }, {
    key: 't',
    value: function t(scope, locals) {
      return this.translate(scope, locals);
    }
  }], [{
    key: 'needsPluralize',
    value: function needsPluralize(translations) {
      var locals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return utils_js.isObject(translations) && typeof locals.count !== 'undefined';
    }

    /**
     * Returns the pluralization key given the count value.
     *
     * @static
     * @method getPluralizeKey
     * @param  {object}   translations
     *   An object of translation data, keys represent scope, values are strings
     * @param  {integer}  count
     *   An integer representing "how many"
     * @return {string}
     *   The key to use for translation, can be `zero` (optional), `one` or `other`
     */

  }, {
    key: 'getPluralizeKey',
    value: function getPluralizeKey(translations, count) {
      var key = count === 1 ? 'one' : 'other';

      if (count === 0 && utils_js.isObject(translations) && translations.hasOwnProperty('zero')) {
        key = 'zero';
      }

      return key;
    }
  }]);

  return I18n;
}();

var i18n = new I18n(window.I18n || {});

module.exports = i18n;
